import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface EmspBoRfidBadgeOrderListEmspUserIdHeaderProps
  extends HeaderContext<
    BackOfficeRfidBadgeOrderModel,
    BackOfficeRfidBadgeOrderModel['emspUser']['id']
  > {}

export const EmspBoRfidBadgeOrderListEmspUserIdHeader =
  (): // props: EmspBoRfidBadgeOrderListEmspUserIdHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-emsp-user.id');
  };
